module.exports = __webpack_public_path__ + "static/img/logo.dc7a0b69.png";